import { createContext, useContext, useEffect, useState } from "react";
import { getThemeInStorage, setThemeInStorage } from "../hooks/usePersistState";

const ThemeContext = createContext({ darkMode: false, handleDarkmode: null });

export function ThemeProvider({ children }) {
    const [darkMode, setDarkMode] = useState(false);
    // change mode here
    function handleDarkmode() {
        setDarkMode(oldMode => {
            setThemeInStorage(oldMode ? 'light' : 'dark')
            return !oldMode
        });
        document.body.classList.toggle('dark');
    }
    // get initial theme from localstorage
    useEffect(() => {
        const theme = getThemeInStorage();
        if (theme) {
            const isDark = theme === 'dark';
            if (isDark) {
                setDarkMode(true)
            }
        }
    }, [])


    return (
        <ThemeContext.Provider value={{ darkMode, handleDarkmode }}>
            {children}
        </ThemeContext.Provider>
    );
}

export function useDarkmodeContext() {
    const { darkMode, handleDarkmode } = useContext(ThemeContext);

    return { darkMode, handleDarkmode };
}
